<div class="svg-container">
  <svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewbox" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    
  </svg>
</div>
